module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper",
    attrs: {
      "id": "topwrap"
    }
  }, [_c('div', {
    attrs: {
      "id": "destination"
    }
  }), _vm._v(" "), _c('second-header', {
    key: _vm.headerKey
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "-4em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.onboarding) ? _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticStyle: {
      "color": "#ff0000"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.payment_message))]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (!_vm.onboarding) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(3), _vm._v(" "), (_vm.show_code_details) ? _c('div', {
    staticClass: "col-sm-8 col-md-offset-2"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/img/cnpay_banner.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-big-white"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('h4', [_vm._v("Your Payment Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("PAYER NAME: ")]), _vm._v(_vm._s(_vm.rrr_txn_details.PAYERNAME))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("RRR AMOUNT: ")]), _vm._v("₦" + _vm._s(_vm.rrr_txn_details.RRRAMOUNT))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("CHARGES: ")]), _vm._v("₦" + _vm._s(_vm.rrr_txn_details.CHARGES))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("NAME: ")]), _vm._v(_vm._s(_vm.rrr_txn_details.NAME))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("DESCRIPTION: ")]), _vm._v(_vm._s(_vm.rrr_txn_details.DESCRIPTION))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("RRR: ")]), _vm._v(_vm._s(_vm.rrr_details.RRR))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("CNpay Convenience Fee: ")]), _vm._v("₦" + _vm._s(_vm.cnpay_proc_fee))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setProcessPayment
    }
  }, [_c('i', {
    staticClass: "fa fa-good"
  }), _vm._v(" "), (!_vm.processing) ? _c('span', [_vm._v("All OK, Continue")]) : _c('span', [_vm._v("Processing..please wait")])])])]) : _vm._e(), _vm._v(" "), (_vm.show_airtime_form_details) ? _c('div', {
    staticClass: "col-sm-8 col-md-offset-2 card-wide-bg"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/img/cnpay_banner1.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-big-white"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("< Back")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(_vm.show_data_bundle) ? _c('button', {
    staticClass: "btn btn-default pull-left",
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPagaAirtimeOrDataBundle()
      }
    }
  }, [_vm._v("Buy Airtime\r\n                                        ")]) : _c('button', {
    staticClass: "btn btn-default pull-left",
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPagaAirtimeOrDataBundle()
      }
    }
  }, [_vm._v("Buy Data Bundle\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount && (_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount > 0)) ? _c('h4', {
    staticStyle: {
      "color": "#850606",
      "font-size": "14px"
    }
  }, [_vm._v("Maximum Purchase Amount: ₦" + _vm._s(_vm.formatCurrency_2(_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount)))]) : _vm._e(), _vm._v(" "), (!_vm.show_data_bundle) ? _c('div', [_c('h4', [_vm._v("Buy " + _vm._s(_vm.paga_merchant.paga_service_group_mobile_operatorName) + " Airtime")]), _vm._v(" "), _c('form', [(_vm.data_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: " col-md-9",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("\r\n                                                    Phone Number\r\n                                                    "), _c('span', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show_set_service_saved_data = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    staticStyle: {
      "margin-left": "10px",
      "color": "#22baae",
      "font-size": "14px"
    }
  })]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show_set_service_saved_data = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "margin-left": "10px",
      "color": "#ff0000",
      "font-size": "14px"
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "margin-left": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both",
      "float": "left"
    }
  }, [(Object.keys(_vm.set_service_saved_data).length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("No saved data")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.set_service_saved_data), function(no, nodex) {
    return _c('div', {
      staticClass: "btn-wrapper"
    }, [(no.merchant_number != '') ? _c('button', {
      staticClass: "btn btn-22",
      on: {
        "click": function($event) {
          _vm.paga_airtime_request.phone_no = no.merchant_number;
          _vm.show_set_service_saved_data = false;
        }
      }
    }, [_vm._v(_vm._s(no.merchant_number) + "\r\n                                                            ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.deleteSaved(nodex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "margin-left": "10px",
        "color": "inherit",
        "font-size": "14px"
      }
    }), _vm._v("  ")])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('label', {
    staticClass: "en-00"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_airtime_request.phone_no),
      expression: "paga_airtime_request.phone_no"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Enter phone number eg. 09088776655"
    },
    domProps: {
      "value": (_vm.paga_airtime_request.phone_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_airtime_request.phone_no = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('label', {
    staticClass: "pull-left",
    staticStyle: {
      "background": "#22baae",
      "padding": "0em 0.3em 0.2em 0.3em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.save_service_data_prompt),
      expression: "save_service_data_prompt"
    }],
    staticStyle: {
      "display": "block !important"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.save_service_data_prompt) ? _vm._i(_vm.save_service_data_prompt, null) > -1 : (_vm.save_service_data_prompt)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.save_service_data_prompt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.save_service_data_prompt = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.save_service_data_prompt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.save_service_data_prompt = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: " save-no",
    staticStyle: {
      "margin-top": "-1.5em"
    }
  }, [_vm._v("  Remember this number?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('label', {
    staticClass: "en-00"
  }, [_vm._v("Amount\r\n                                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_airtime_request.amount),
      expression: "paga_airtime_request.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Amount"
    },
    domProps: {
      "value": (_vm.paga_airtime_request.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_airtime_request.amount = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary pull-left",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPagaProcessPayment(_vm.paga_merchant, _vm.paga_merchant.paga_service_group_merchant_service_group_type)
      }
    }
  }, [_vm._v("Enter")])])])]) : _vm._e(), _vm._v(" "), (_vm.show_data_bundle) ? _c('div', [(_vm.paga_merchant.dataBundles && (_vm.paga_merchant.dataBundles.length != 0)) ? _c('div', [_c('h4', [_vm._v("Select " + _vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName) + " Data Bundle")]), _vm._v(" "), _vm._l((_vm.paga_merchant.dataBundles), function(service, index) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-12"
    }, [_c('div', {
      staticClass: "card-links-wrap-box"
    }, [_c('li', {
      staticClass: "card-links-wrap"
    }, [_c('a', {
      staticClass: "card-links",
      on: {
        "click": function($event) {
          _vm.prepDataBundleSetPagaProcessPayment(service, 'MOBILEDATA')
        }
      }
    }, [_vm._v("\r\n                                                            " + _vm._s(service.serviceName)), (service.servicePrice != 0) ? _c('span', [_vm._v(" - ₦" + _vm._s(service.servicePrice))]) : _vm._e()]), _vm._v(" "), (_vm.show_data_bundle_phone_number_field && (_vm.paga_merchant.serviceToPay.serviceId == service.serviceId)) ? _c('div', {
      key: _vm.dataBundleComponentKey,
      staticClass: " card-links-wrap-box-2",
      staticStyle: {
        "height": "200px"
      }
    }, [(_vm.data_error_message != '') ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: " col-md-9",
      staticStyle: {
        "padding": "0"
      }
    }, [_vm._v("\r\n                                                                    Phone Number\r\n                                                                    "), _c('span', [_c('a', {
      staticStyle: {
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.show_set_service_saved_data = true;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clipboard",
      staticStyle: {
        "margin-left": "10px",
        "color": "#22baae",
        "font-size": "14px"
      }
    })]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('a', {
      staticStyle: {
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.show_set_service_saved_data = false;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "margin-left": "6px",
        "color": "#ff0000",
        "font-size": "14px"
      }
    })]) : _vm._e()])]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('div', {
      staticStyle: {
        "clear": "both",
        "margin-top": "-10px",
        "margin-left": "1em"
      }
    }, [_c('div', {
      staticStyle: {
        "clear": "both",
        "float": "left"
      }
    }, [(Object.keys(_vm.set_service_saved_data).length == 0) ? _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("No saved data")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.set_service_saved_data), function(no, nodex) {
      return _c('div', {
        staticClass: "btn-wrapper"
      }, [_vm._l((_vm.set_service_saved_data), function(no) {
        return (no.merchant_number != '') ? _c('button', {
          staticClass: "btn btn-22",
          on: {
            "click": function($event) {
              _vm.paga_bundle_request.phone_no = no.merchant_number;
              _vm.show_set_service_saved_data = false;
            }
          }
        }, [_vm._v(_vm._s(no.merchant_number))]) : _vm._e()
      }), _vm._v(" "), _c('a', {
        staticStyle: {
          "color": "inherit",
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.deleteSaved(nodex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close",
        staticStyle: {
          "margin-left": "10px",
          "color": "inherit",
          "font-size": "14px"
        }
      }), _vm._v("  ")])], 2)
    })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both",
        "float": "left"
      }
    }, [_c('label', {
      staticClass: "en-00"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_bundle_request.phone_no),
        expression: "paga_bundle_request.phone_no"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": "Enter phone number eg. 09088776655"
      },
      domProps: {
        "value": (_vm.paga_bundle_request.phone_no)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.paga_bundle_request.phone_no = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('label', {
      staticClass: "pull-left",
      staticStyle: {
        "background": "#22baae",
        "padding": "0em 0.3em 0.2em 0.3em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.save_service_data_prompt),
        expression: "save_service_data_prompt"
      }],
      staticStyle: {
        "display": "block !important"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.save_service_data_prompt) ? _vm._i(_vm.save_service_data_prompt, null) > -1 : (_vm.save_service_data_prompt)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.save_service_data_prompt,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.save_service_data_prompt = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.save_service_data_prompt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.save_service_data_prompt = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: " save-no",
      staticStyle: {
        "margin-top": "-1.5em"
      }
    }, [_vm._v("  Remember this number?")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-group",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [(_vm.disable_btn) ? _c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("...processing, please wait")]) : _c('button', {
      staticClass: "btn btn-primary btn-xs pull-left",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setPagaProcessPayment(service, 'MOBILEDATA')
        }
      }
    }, [_vm._v("Send")]), _vm._v("\r\n                                                                   "), (!_vm.disable_btn) ? _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.reset_data_bundle()
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e()])]) : _vm._e()])])])
  })], 2) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No " + _vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName) + " Services here yet.")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.show_paga_service_details) ? _c('div', {
    staticClass: "col-sm-8 col-md-offset-2 card-wide-bg"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/img/cnpay_banner1.png"
    }
  }), _vm._v(" "), _c('div', {
    key: _vm.serviceToPayComponentKey,
    staticClass: "card-big-white"
  }, [_c('div', [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("< Back")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.paga_merchant.services && (_vm.paga_merchant.services.length != 0)) ? _c('div', [_c('h4', [_vm._v("Select from " + _vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName) + " Services")]), _vm._v(" "), _vm._l((_vm.paga_merchant.services), function(service, index) {
    return (!((_vm.paga_merchant.paga_service_group_merchant_services_do_not_display_names).includes(service.serviceName))) ? _c('div', {
      staticClass: "col-md-4 col-sm-12 card-links-wrap-box"
    }, [_c('li', {
      staticClass: "card-links-wrap"
    }, [_c('a', {
      staticClass: "card-links",
      on: {
        "click": function($event) {
          _vm.prepSetPagaProcessPayment(service, _vm.paga_merchant.paga_service_group_merchant_service_group_type)
        }
      }
    }, [_vm._v("\r\n                                                        " + _vm._s(service.serviceName)), (service.servicePrice != 0) ? _c('span', [_vm._v(" - ₦" + _vm._s(service.servicePrice))]) : _vm._e()])])]) : _vm._e()
  })], 2) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No " + _vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName) + " Services here yet.")])])])])]) : _vm._e(), _vm._v(" "), ((!_vm.show_paga_service_details && !_vm.show_code_details && !_vm.show_airtime_form_details)) ? _c('div', {
    staticClass: "card_wide"
  }, [(_vm.loading) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "line-card-2"
  }, [_c('p', {
    staticClass: "p-intro"
  }, [_vm._v("Make Remita Payments")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('form', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [(_vm.rrr_err_message != '') ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.rrr_err_message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rrr.rrr_code),
      expression: "rrr.rrr_code"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "placeholder": "Enter RRR Code"
    },
    domProps: {
      "value": (_vm.rrr.rrr_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rrr.rrr_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.processCode()
      }
    }
  }, [(!_vm.rloading) ? _c('span', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v("PAY NOW")]) : _c('span', [_vm._v(" Loading ... ")])])])])])]), _vm._v(" "), _vm._l((_vm.paga_service_groups), function(group) {
    return _c('div', {}, [(group.paga_service_group_for == 'MOBILEOPS') ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "line-card-2"
    }, [_c('p', {
      staticClass: "p-intro"
    }, [_vm._v(_vm._s(group.paga_service_group_title))]), _vm._v(" "), _vm._l((group.paga_service_group_merchants), function(merchant, index) {
      return _c('div', {
        staticClass: "col-xs-4",
        staticStyle: {
          "padding": "2px"
        }
      }, [_c('div', {}, [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "inherit"
        },
        attrs: {
          "title": merchant.paga_service_group_mobile_operatorName
        },
        on: {
          "click": function($event) {
            _vm.prepPagaAirtimeServices(merchant, ('load-xs' + index))
          }
        }
      }, [(merchant.paga_service_group_merchant_attached_image != '') ? _c('div', [_c('img', {
        staticClass: "service-pay-logo-2",
        attrs: {
          "src": _vm.img_url + merchant.paga_service_group_merchant_attached_image
        }
      })]) : _c('div', [_c('p', {
        staticClass: "service-pay-title-logo"
      }, [_vm._v(_vm._s(merchant.paga_service_group_mobile_operatorName))])]), _vm._v(" "), ((_vm.paga_merchant.paga_service_group_merchant_id == merchant.paga_service_group_merchant_id) && (_vm.paga_merchant.loading)) ? _c('div', {
        staticClass: "wn-loader-xs"
      }) : _vm._e()])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 2)]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.paga_service_groups), function(group) {
    return _c('div', [(group.paga_service_group_for == 'MERCHANT') ? _c('div', {
      staticClass: "col-md-4 col-xs-12",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "line-card-2"
    }, [_c('p', {
      staticClass: "p-intro"
    }, [_vm._v(_vm._s(group.paga_service_group_title))]), _vm._v(" "), _vm._l((group.paga_service_group_merchants), function(merchant, index) {
      return _c('div', {
        staticClass: "col-xs-4",
        staticStyle: {
          "padding": "2px"
        }
      }, [_c('div', {}, [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "inherit"
        },
        attrs: {
          "title": merchant.paga_service_group_merchant_displayName
        },
        on: {
          "click": function($event) {
            _vm.getPagaMerchantServices(merchant, ('load-xs' + index))
          }
        }
      }, [(merchant.paga_service_group_merchant_attached_image != '') ? _c('span', [_c('img', {
        staticClass: "service-pay-logo-2",
        attrs: {
          "src": _vm.img_url + merchant.paga_service_group_merchant_attached_image
        }
      })]) : _c('span', [_c('p', {
        staticClass: "service-pay-title-logo"
      }, [_vm._v(_vm._s(merchant.paga_service_group_merchant_displayName))])]), _vm._v(" "), ((_vm.paga_merchant.paga_service_group_merchant_id == merchant.paga_service_group_merchant_id) && (_vm.paga_merchant.loading)) ? _c('div', {
        staticClass: "wn-loader-xs"
      }) : _vm._e()])])])
    })], 2)]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "5em"
    },
    attrs: {
      "id": "paywith",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [(!_vm.show_payment_receipt) ? _c('div', [_vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.show_payment_receipt) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "342px !important"
    },
    attrs: {
      "id": "paymod"
    }
  }, [_c('div', {
    staticClass: "table",
    staticStyle: {
      "margin-top": "1em",
      "color": "#000000",
      "font-weight": "bolder",
      "margin-bottom": "0.1em !important"
    }
  }, [_c('table', [_c('tr', {}, [_vm._m(6), _vm._v(" "), _c('td', [_c('div', {
    staticStyle: {
      "margin-bottom": "0.1em",
      "margin-left": "6px"
    }
  }, [(_vm.payment_receipt_details.payment_merchant_logo != '') ? _c('span', [_c('img', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "src": _vm.img_url + _vm.payment_receipt_details.payment_merchant_logo
    }
  })]) : _c('span', [_c('p', {
    staticClass: "service-pay-title-logo"
  }, [_vm._v(_vm._s(_vm.payment_receipt_details.payment_merchant_name))])])])])])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "table rctable",
    staticStyle: {
      "color": "#000000",
      "font-weight": "bolder"
    }
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("Payment:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_merchant_service))])]), _vm._v(" "), (_vm.payment_receipt_details.payment_payer_merchant_name != '') ? _c('tr', [_c('td', [_vm._v("From:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_payer_merchant_name))])]) : _vm._e(), _vm._v(" "), ((_vm.payment_receipt_details.payment_merchant_code_number && (_vm.payment_receipt_details.payment_merchant_code_number != ''))) ? _c('tr', [_c('td', [_vm._v("Number:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_merchant_code_number))])]) : _vm._e(), _vm._v(" "), (_vm.payment_receipt_details.payment_payer_merchant_address != '') ? _c('tr', [_c('td', [_vm._v("Address:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_payer_merchant_address))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Date:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_date))])]), _vm._v(" "), (_vm.payment_receipt_details.payment_formatted_token_voucher != 0) ? _c('tr', [_c('td', [_vm._v("Token:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_formatted_token_voucher))])]) : _vm._e(), _vm._v(" "), (((_vm.payment_receipt_details.payment_merchant_service_purchased_units_type) && ((_vm.payment_receipt_details.payment_merchant_service_purchased_units_type != '') || (_vm.payment_receipt_details.payment_merchant_service_purchased_units_type != undefined)))) ? _c('tr', [_c('td', [_vm._v("Units:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_merchant_service_purchased_units_type))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Amount:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.payment_receipt_details.payment_amount)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CNpay Charges:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.service_charge)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.total_fee)))])]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.printDiv('paymod', 'Utility Bill Receipt')
      }
    }
  }, [_vm._v("Print")]), _vm._v("   \r\n                        "), _c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveDiv('paymod', 'Utility Bill Receipt')
      }
    }
  }, [_vm._v("Save\r\n                            "), (_vm.downloading) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/assets/img/loader.gif",
      "height": "20"
    }
  })]) : _vm._e()]), _vm._v("   \r\n                        "), _c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('br'), _c('br'), _c('br')]) : _c('div', [(_vm.payment_message != '') ? _c('div', [_c('h5', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(_vm._s(_vm.payment_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "14px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v(_vm._s(_vm.payment_service_message))]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Thank you for choosing CNpay.")]), _vm._v(" "), (Object.keys(_vm.payment_receipt_details).length > 0) ? _c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show_payment_receipt = true
      }
    }
  }, [_vm._v("View Details")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_code_details && _vm.payment_message == '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.formatCurrency(_vm.total_fee)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Process Payment with your CNpay Rewards")]), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Available Balance: ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))]), _vm._v(" "), (_vm.current_wallet_balance >= _vm.total_fee) ? _c('div', [(_vm.disable_btn_wallet) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn_wallet,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepProcessPayment('wallet')
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Insufficient balance.")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setLogin()
      }
    }
  }, [_vm._v("Login")]), _vm._v(" to use your CNpay Rewards")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Or")]), _vm._v(" "), _c('h5', [_vm._v("Process payment from your Bank Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepProcessPayment('gateway')
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])]) : _vm._e(), _vm._v(" "), (_vm.payment_message == '') ? _c('div', [(_vm.show_paga_service_details || _vm.show_airtime_form_details) ? _c('div', {
    staticStyle: {
      "padding": "2px 1em"
    }
  }, [(_vm.show_paga_service_details) ? _c('div', {
    staticClass: "row"
  }, [(_vm.setPayWithOption) ? _c('h5', [_c('b', [_vm._v("Purchase: ")]), _vm._v(_vm._s(_vm.paga_merchant.serviceToPay.serviceName))]) : _vm._e(), _vm._v(" "), (_vm.setPayWithOption) ? _c('h5', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.formatCurrency(_vm.total_fee)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_airtime_form_details) ? _c('div', {
    staticClass: "row"
  }, [(_vm.show_data_bundle) ? _c('h5', [_vm._v("Buy Data Bundle"), _c('br'), _c('b', [_vm._v(" ₦" + _vm._s(_vm.paga_bundle_request.servicePrice) + " - " + _vm._s(_vm.paga_merchant.paga_service_group_mobile_operatorName) + " - " + _vm._s(_vm.paga_bundle_request.serviceName))]), _c('br'), _vm._v("Phone Number: " + _vm._s(_vm.paga_bundle_request.phone_no)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Total Amount to Pay: ₦" + _vm._s(_vm.formatCurrency(_vm.total_fee)))])]) : _c('h5', [_vm._v("Buy "), _c('b', [_vm._v(" ₦" + _vm._s(_vm.paga_airtime_request.amount) + " - " + _vm._s(_vm.paga_merchant.paga_service_group_mobile_operatorName))]), _vm._v(" Airtime"), _c('br'), _vm._v("Phone Number: " + _vm._s(_vm.paga_airtime_request.phone_no)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Total Amount to Pay: ₦" + _vm._s(_vm.formatCurrency(_vm.total_fee)))])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('form', {
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.loggedIn) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.data_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Please, fill in your details to process payment")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Full Name: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerName),
      expression: "customer.customerName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Full Name"
    },
    domProps: {
      "value": (_vm.customer.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email\r\n                                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerEmail),
      expression: "customer.customerEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Enter Your Email Address"
    },
    domProps: {
      "value": (_vm.customer.customerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerEmail = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('b', [_vm._v("Name: " + _vm._s(_vm.customer.customerName))])]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Email: " + _vm._s(_vm.customer.customerEmail))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount && (_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount > 0)) ? _c('h4', {
    staticStyle: {
      "color": "#850606",
      "font-size": "14px"
    }
  }, [_vm._v("Maximum Purchase Amount: ₦" + _vm._s(_vm.formatCurrency_2(_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount)))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\"The maximum purchase amount you can make per transaction is ₦" + _vm._s(_vm.formatCurrency_2(_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount)) + ", at a go. To purchase more, reduce the subsequent purchase amount(s). For example, to buy ₦100,000 or more, start with ₦50,000, then ₦49,999, ₦49,998, and so on\".")]), _vm._v(" "), (_vm.show_paga_service_details) ? _c('form', {
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.setPayWithOption) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Please, fill in your details")]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn && !_vm.setPayWithOption) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.data_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Full Name: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerName),
      expression: "customer.customerName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Full Name"
    },
    domProps: {
      "value": (_vm.customer.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerEmail),
      expression: "customer.customerEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.customer.customerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.data_phone_error_message) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data_phone_error_message))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Phone Number: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerPhoneNumber),
      expression: "customer.customerPhoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Phone Number"
    },
    domProps: {
      "value": (_vm.customer.customerPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerPhoneNumber = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('b', [_vm._v("Name: " + _vm._s(_vm.customer.customerName))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.data_phone_error_message) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data_phone_error_message))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Phone Number: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerPhoneNumber),
      expression: "customer.customerPhoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.customer.customerPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerPhoneNumber = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.setPayWithOption) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: " col-md-9",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('p', [_vm._v("Enter your "), _c('b', [_vm._v(_vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName))]), _vm._v(" Number: \r\n                                            "), _c('span', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show_set_service_saved_data = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    staticStyle: {
      "margin-left": "10px",
      "color": "#22baae",
      "font-size": "14px"
    }
  })]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show_set_service_saved_data = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "margin-left": "10px",
      "color": "#ff0000",
      "font-size": "14px"
    }
  })]) : _vm._e()])])]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "margin-left": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both",
      "float": "left"
    }
  }, [(Object.keys(_vm.set_service_saved_data).length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("No saved data")]) : _vm._e(), _c('br'), _vm._v(" "), _vm._l((_vm.set_service_saved_data), function(no, nodex) {
    return _c('div', {
      staticClass: "btn-wrapper"
    }, [(no.merchant_number != '') ? _c('button', {
      staticClass: "btn btn2",
      on: {
        "click": function($event) {
          _vm.customer.customerCodeAtBiller = no.merchant_number;
          _vm.show_set_service_saved_data = false;
        }
      }
    }, [(no.merchant_number_name != '') ? _c('span', {
      staticStyle: {
        "font-size": "12x",
        "padding-bottom": "5px"
      }
    }, [_vm._v(_vm._s(no.merchant_number_name)), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(_vm._s(no.merchant_number) + "\r\n                                                    ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.deleteSaved(nodex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "margin-left": "10px",
        "color": "inherit",
        "font-size": "14px"
      }
    }), _vm._v("  ")])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "en-00"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerCodeAtBiller),
      expression: "customer.customerCodeAtBiller"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.customer.customerCodeAtBiller)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerCodeAtBiller = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('label', {
    staticClass: "pull-left",
    staticStyle: {
      "background": "#22baae",
      "padding": "0em 0.3em 0.2em 0.3em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.save_service_data_prompt),
      expression: "save_service_data_prompt"
    }],
    staticStyle: {
      "display": "block !important"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.save_service_data_prompt) ? _vm._i(_vm.save_service_data_prompt, null) > -1 : (_vm.save_service_data_prompt)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.save_service_data_prompt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.save_service_data_prompt = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.save_service_data_prompt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.save_service_data_prompt = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: " save-no",
    staticStyle: {
      "margin-top": "-1.5em"
    }
  }, [_vm._v("  Remember this number?")])])]), _vm._v(" "), (_vm.paga_merchant.serviceToPay && (_vm.paga_merchant.serviceToPay.servicePrice != 0)) ? _c('label', {
    key: _vm.serviceToPayComponentKey,
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("Amount to Purchase: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_merchant.serviceToPay.servicePrice),
      expression: "paga_merchant.serviceToPay.servicePrice"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.paga_merchant.serviceToPay.servicePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_merchant.serviceToPay.servicePrice = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.paga_merchant.serviceToPay && (_vm.paga_merchant.serviceToPay.servicePrice == 0)) ? _c('label', {
    key: _vm.serviceToPayComponentKey,
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("Amount to Purchase: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_merchant.serviceToPay.servicePrice),
      expression: "paga_merchant.serviceToPay.servicePrice"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.paga_merchant.serviceToPay.servicePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_merchant.serviceToPay.servicePrice = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.setPayWithOption) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v("Account Details: ")]), _vm._v(_vm._s(_vm.customer_received_details.customerName))]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName) + " Number: ")]), _vm._v(_vm._s(_vm.customer.customerCodeAtBiller))])]) : _vm._e(), _vm._v(" "), (!_vm.setPayWithOption) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPagaProcessPayment(_vm.paga_merchant.serviceToPay, _vm.serviceToPayFor)
      }
    }
  }, [_vm._v("Enter")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.setPayWithOption) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(10), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Available Balance: ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))]), _vm._v(" "), (_vm.current_wallet_balance >= _vm.total_fee) ? _c('div', [(_vm.disable_btn_wallet) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn_wallet,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepPagaProcessPayment('wallet')
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Insufficient balance.")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setLogin()
      }
    }
  }, [_vm._v("Login")]), _vm._v(" to use your CNpay Rewards")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(11), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepPagaProcessPayment('gateway')
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])]) : _vm._e()])]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "login",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-header login-modal-header",
    staticStyle: {
      "z-index": "3"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    staticStyle: {
      "z-index": "9",
      "border-radius": "50%"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('login')
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('h1', [_vm._v("Can you keep a secret?")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.login_script) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#000000",
      "line-height": "2.0",
      "font-size": "16px"
    }
  }, [_vm._v("Cityneeds rewards customers who pay bills while logged-in.\r\n                                        Log in to your account, or register if you don't have an account, then proceed with your transaction, to receive instant cashback (your reward) in your CNpay account.\r\n                                ")])]) : _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Login")])]), _vm._v(" "), _c('form', {
    staticClass: "col-sm-8 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login-form-email"
    }
  }, [_vm._v("E-mail or Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "id": "login-form-email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login-form-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "login-form-password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.disable_btn_login) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn_login,
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _vm._m(12)])])])])]), _vm._v(" "), _vm._m(13)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "24em"
    },
    attrs: {
      "id": "topup",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#topup')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.wallet_payment_message != '') ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.wallet_payment_message))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("..reloading wallet")])]) : _c('div', [(_vm.wallet_payment_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.wallet_payment_error_message))]) : _vm._e(), _vm._v(" "), (_vm.wallet_payment_calculated) ? _c('div', [_c('h5', [_vm._v("Amount: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.topay_amt)))]), _vm._v(" "), _c('h5', [_vm._v("Processing Fee: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.processing_fee)))]), _vm._v(" "), _c('h6', [_vm._v("Total: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.topay_amt + _vm.wallet_transaction.processing_fee)))]), _vm._v(" "), (_vm.disable_topup_wallet_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_topup_wallet_btn
    },
    on: {
      "click": _vm.makePayment
    }
  }, [_vm._v("Proceed")])]) : _c('div', [_c('h4', [_vm._v("How much would you like to top-up with?")]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "font-size": "13px",
      "border": "thin #22baae 1px",
      "text-align": "left",
      "border-radius": "2px",
      "background": "rgba(238, 229, 106, 0.473)",
      "line-height": "1.8"
    }
  }, [_vm._v("\r\n                            CNpay is a Closed Wallet. Top-up into CNpay CANNOT BE TRANSFERRED NOR WITHDRAWN AS CASH; funds in CNpay can only be spent within Cityneeds' platform for the purchase of Cityneeds' products and services.\r\n                        ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "11px"
    }
  }, [_vm._v("Top-up from ₦" + _vm._s(_vm.min_wallet_topup_amount) + " to ₦" + _vm._s(_vm.max_wallet_topup_amount))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wallet_transaction.topay_amt),
      expression: "wallet_transaction.topay_amt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "100",
      "placeholder": "Enter Amount"
    },
    domProps: {
      "value": (_vm.wallet_transaction.topay_amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wallet_transaction.topay_amt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prepareWalletPayment
    }
  }, [_vm._v("Enter")])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Make Another Payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("@"), _c('b', [_vm._v("cityneeds")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-cta"
  }, [_c('h3', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("What would you like to do with cityneeds today")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng/cnpros"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Find CNpros"), _c('br'), _c('i', [_vm._v("service workers")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng/cnsurveys"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Take a Survey"), _c('br'), _c('i', [_vm._v("CNsurveys")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng/forums"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("City Discussions"), _c('br'), _c('i', [_vm._v("join")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng/businesses"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Search Businesses"), _c('br'), _c('i', [_vm._v("pre-verified")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cnpay.cityneeds.ng"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Make Payments\r\n                                                "), _c('br'), _c('i', [_vm._v("with CNpay")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Talk to a CNagent"), _c('br'), _vm._v(" "), _c('i', [_vm._v("call 08032258453")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', {
    staticClass: "headings",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae"
    }
  }, [_vm._v("CN")]), _c('span', {
    staticStyle: {
      "color": "#e7c619"
    }
  }, [_vm._v("pay")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "-1em"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('b', [_vm._v("pay bills with a click 👌")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pull-left col-md-2 col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('li', {
    staticClass: "line-list"
  }, [_c('img', {
    staticClass: "service-pay-logo-1",
    attrs: {
      "src": "static/assets/img/Remita-Logo.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "-2em",
      "margin-left": "1em"
    }
  }, [_c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("CN")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("pay")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("pay bills with a click 👌")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "-2em",
      "margin-left": "1em"
    }
  }, [_c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("CN")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("pay")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("pay bills with a click 👌")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('u', [_vm._v("CNpay Payment Receipt")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Transaction Status:")]), _vm._v(" "), _c('td', [_vm._v("Completed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "1em",
      "margin-left": "1em",
      "font-size": "11px",
      "text-align": "left"
    }
  }, [_vm._v("Thank you for choosing CNpay."), _c('br'), _vm._v("\r\n                                Cityneeds™ ... meet everyday needs on the go!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("1. ")]), _vm._v("Process Payment with your CNpay Rewards")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("2. ")]), _vm._v("Process Payment from your Bank Account")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-right m-t-xs text-sm pull-left"
  }, [_c('a', {
    attrs: {
      "href": "https://cityneeds.ng/login"
    }
  }, [_vm._v("Forgot Password?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer login-modal-footer"
  }, [_c('p', {
    staticClass: "text-left m-t-xs text-sm",
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Don't have an account?")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-block m-t-xs",
    attrs: {
      "href": "https://cityneeds.ng/register"
    }
  }, [_vm._v("Register")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab6b632"}!./src/components/CNpay/template.html
// module id = 101
// module chunks = 1